export default "__VITE_ASSET__COexvm6t__"